export { default } from './CalendarPanelFooter.js';

/** Default options for the Date.toLocaleDateString function call */

export const defaultDateToStringOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
};
